module.exports = __webpack_public_path__ + "media/scholarship_winners/jonathan-d-44572c84.png";